import { ThinkingMessage } from './thinking-message.component';
import { ErrorMessage } from './error-message.component';
import { ResponseMessage } from './response-message.component';
import { PromptMessage } from './prompt-message.component';
import { DefaultMessage } from './default-message.component';
import type { MessageComponentMap } from './message-types.types';

export type {
  MessageType,
  MessageComponentProps,
  MessageComponentMap,
} from './message-types.types';

export const messageComponents: MessageComponentMap = {
  thinking: ThinkingMessage,
  error: ErrorMessage,
  response: ResponseMessage,
  prompt: PromptMessage,
};

export { DefaultMessage };
